function chain() {
  for (var _len = arguments.length, callbacks = new Array(_len), _key = 0; _key < _len; _key++) {
    callbacks[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var fns = callbacks.filter(Boolean);
    fns.forEach(function (callback) {
      return callback.apply(void 0, args);
    });
  };
}
export var clsx = function clsx() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return args.filter(Boolean).join(' ');
};
function mergePropsInner(a, b) {
  var res = {};
  Object.keys(a).forEach(function (key) {
    var _b$key;
    if (/^on[A-Z]/.test(key) && typeof a[key] === 'function' && typeof b[key] === 'function') {
      res[key] = chain(a[key], b[key]);
      return;
    }
    if (key === 'className') {
      var _a$className, _b$className;
      var left = (_a$className = a.className) === null || _a$className === void 0 ? void 0 : _a$className.toString();
      var right = (_b$className = b.className) === null || _b$className === void 0 ? void 0 : _b$className.toString();
      res[key] = clsx(left, right);
      return;
    }
    res[key] = (_b$key = b[key]) !== null && _b$key !== void 0 ? _b$key : a[key];
  });
  Object.keys(b).filter(function (key) {
    return !(key in a);
  }).forEach(function (key) {
    res[key] = b[key];
  });
  return res;
}
export function mergeProps() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }
  return args.reduce(function (left, right) {
    return mergePropsInner(left, right);
  });
}